import { render } from "./YazamData.vue?vue&type=template&id=e22b1a30&scoped=true"
import script from "./YazamData.vue?vue&type=script&lang=js"
export * from "./YazamData.vue?vue&type=script&lang=js"

import "./YazamData.vue?vue&type=style&index=0&id=e22b1a30&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e22b1a30"],['__file',"src/components/YazamData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e22b1a30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e22b1a30', __exports__)) {
    api.reload('e22b1a30', __exports__)
  }
  
  module.hot.accept("./YazamData.vue?vue&type=template&id=e22b1a30&scoped=true", () => {
    api.rerender('e22b1a30', render)
  })

}


export default __exports__